export const LAST_NAME_MISSING_MESSAGE =
  'Last name missing. Utilization only had a first name and a driver number. Add the last name here.';

/**
 * Employee details shows driver_number when the role is Driver (LYN-409).
 * Payroll employee_number stays a separate field.
 * @param {{ driverNumber?: string|null, isDriver?: boolean, roles?: Array<{ name?: string }> }|null|undefined} employee
 * @returns {boolean}
 */
export function shouldShowDriverNumber(employee) {
  if (!employee || employee.driverNumber == null || employee.driverNumber === '') {
    return false;
  }
  if (employee.isDriver === true) return true;
  const roles = employee.roles;
  if (Array.isArray(roles)) {
    return roles.some((role) => role && role.name === 'Driver');
  }
  return true;
}

/**
 * Utilization first-name-only drivers need an operator-supplied last name.
 * @param {{ lastName?: string|null, driverNumber?: string|null }|null|undefined} employee
 * @param {string} [lastNameValue]
 * @returns {boolean}
 */
export function shouldShowLastNameMissing(employee, lastNameValue) {
  if (!employee) return false;
  const driver = employee.driverNumber;
  const hasDriver = driver != null && String(driver).trim() !== '';
  if (!hasDriver) return false;
  const last = lastNameValue !== undefined ? lastNameValue : employee.lastName;
  return last == null || String(last).trim() === '';
}
